export enum ProductRuleCondition {
    Equals = 'Equals',
    NotEquals = 'NotEquals',
}
